import React, { useEffect } from 'react';
import { useClickOutside } from 'react-click-outside-hook';

export const OutsideClickWrapper: React.FC<{ onOutsideClick: () => void; children: React.ReactNode }> = ({
  onOutsideClick,
  children,
}) => {
  const [ref, hasClickedOutside] = useClickOutside();

  useEffect(() => {
    if (hasClickedOutside) {
      onOutsideClick();
    }
  }, [hasClickedOutside, onOutsideClick]);

  return <div ref={ref}>{children}</div>;
};
